<template>
  <div>
    <div style="display:flex;margin-top:20px;">
      <el-card class="box-card infobox">
        <el-row class="text item infoItem">
          <el-col :span="12">用户名：<a target="_blank" :href="'http://jazpan.com/user/' + getUserInfo.uid">
              {{ getUserInfo.name }}
            </a>
            <i class="el-icon-edit-outline" style="cursor: pointer;color:red;font-weight: bold;" alt="可使用密码登录"
              @click="$refs.NameForm.show()" v-if="getUserInfo.tmpname == 1" />
          </el-col>
          <el-col :span="12">ID：{{ getUserInfo.uid }}</el-col>
        </el-row>
        <el-row class="text item infoItem">
          <el-col :span="12">昵称：{{ getUserInfo.nick }}</el-col>
          <el-col :span="12">注册时间：{{ getUserInfo.times }}</el-col>
        </el-row>
        <el-row class="text item infoItem" v-if="balances > 0.0 || balancetx > 0.0">
          <el-col :span="12">余额：<span class="amountxs">{{ balances }}</span></el-col>
          <el-col :span="12">正在提现：<span class="amountxs">{{ balancetx }}</span></el-col>
        </el-row>
        <el-row class="text item infoItem">
          <el-col :span="12">VIP1：<span>{{ getUserInfo.vip1 }}</span></el-col>
          <el-col :span="12">VIP2：<span>{{ getUserInfo.vip2 }}</span></el-col>
        </el-row>
        <el-row class="text item infoItem">
          简介：{{ getUserInfo.desc }}
        </el-row>
        <el-row class="text item infoItem">
          <el-button type="primary" size="small" v-on:click="$refs.proEdit.show()">修改资料</el-button>
          <el-button type="primary" size="small" v-on:click="$refs.avatEdit.show()">修改头像</el-button>
          <!-- <el-button type="primary" size="small" v-on:click="$refs.chongZhiDlg.show()">充值余额</el-button> -->
          <el-button type="primary" size="small" v-on:click="$refs.chongVipDlg.show()"
            v-if="balances > 0.0">充值VIP</el-button>
          <el-button type="warning" size="small" v-on:click="tixianFun" v-if="balances > 0.0">提现</el-button>
          <el-button type="info" size="small" v-on:click="$router.push('/txs')" v-if="balances > 0.0">提现记录</el-button>
        </el-row>
      </el-card>
      <!-- <el-card class="box-card rankbox" v-show="showTxRank">
        <div class="tits">
          <div style="flex:1">提现展示</div> <el-button type="text" @click="showTxRank = false;">关闭</el-button>
        </div>
        <div>
          <ul class="rankul">
            <li v-for="it in txRanks" :key="'txRank:' + it.Id">
              <div class="lefts">
                <span class="name">{{ it.Nick }}</span> 提现: <span class="amountxs">{{ it.Amounts }}元</span>
              </div>
              <div class="rights">{{ it.Timestr }}</div>
            </li>
            <li>
              <div class="lefts">......</div>
            </li>
          </ul>
        </div>
      </el-card> -->
    </div>
    <div style="display:flex;margin-top:20px;" v-show="balances > 0.0">
      <el-card class="box-card chartsbox">
        <div id="blChart1" style="width:100%; height:300px;"></div>
      </el-card>
      <el-card class="box-card chartsbox">
        <div id="blChart2" style="width:100%; height:300px;"></div>
      </el-card>
    </div>
    <NameForm ref="NameForm" />
    <proEdit ref="proEdit" />
    <avatEdit ref="avatEdit" />
    <txEdit ref="txEdit" @submitOK="getBalances()" />
    <txTaxEdit ref="txTaxEdit" @submitOK="getBalances()" />
    <ChongVip ref="chongVipDlg" @submitOK="refreshPg()" />
    <ChongZhi ref="chongZhiDlg" @submitOK="refreshPg()" />
  </div>
</template>

<script>
import * as echarts from 'echarts';
import NameForm from '@/views/ruis/user/NameForm';
import proEdit from '@/views/ruis/user/proEdit';
import avatEdit from '@/views/ruis/user/avatEdit';
import txEdit from '@/views/ruis/user/txEdit';
import txTaxEdit from '@/views/ruis/user/txTaxEdit';
import ChongVip from '@/components/ChongVip'
import ChongZhi from '@/components/ChongZhi'
import { mapGetters } from 'vuex'
export default {
  components: { NameForm, proEdit, avatEdit, txEdit, txTaxEdit, ChongVip, ChongZhi },
  data() {
    return {
      balances: '0.0',
      balancetx: '0.0',
      blChart1: null,
      blChart2: null,
      showTxRank: true,
      txRanks: [],
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'getUserInfo'
    ])
  },
  mounted() {
    this.balances = this.getUserInfo.balances;
    this.getBalances();
    // this.getTxRank();
  },
  methods: {
    refreshPg() {
      window.top.location.reload();
    },
    getBalances() {
      this.$post('/user/balance').then(res => {
        this.balances = res.data.balances;
        this.balancetx = res.data.balancetx;
        this.drawBlChart1();
        this.drawBlChart2();
      }).catch(err => {
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    tixianFun() {
      if (this.getUserInfo.txstat > 0)
        this.$refs.txTaxEdit.show()
      else
        this.$refs.txEdit.show()
    },
    getTxRank() {
      this.$post('/user/txsrank', { limit: 20 }).then(res => {
        this.txRanks = res.data;
      }).catch(err => {
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    drawBlChart1() {
      this.blChart1 = echarts.init(document.getElementById('blChart1'));
      this.$post('/user/balances/1').then(res => {
        console.log('balances data:', res.data);
        this.blChart1.setOption({
          title: {
            text: '收入详情（单位：元）',
            textStyle: { color: '#f60' }
          },
          tooltip: {},
          xAxis: {
            data: ["今日", "昨日", "前7日", "本月", "上个月", "今年"/* , "去年" */]
          },
          yAxis: {},
          series: [{
            name: '元',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              normal: {
                color: '#f60'
              }
            },
            data: res.data
          }]
        });
      })
    },
    drawBlChart2() {
      this.blChart2 = echarts.init(document.getElementById('blChart2'));
      this.$post('/user/balances/2').then(res => {
        console.log('balances data:', res.data);
        this.blChart2.setOption({
          title: {
            text: '支出详情（单位：元）',
            textStyle: { color: '#5470c6' },
          },
          tooltip: {},
          xAxis: {
            data: ["今日", "昨日", "前7日", "本月", "上个月", "今年"/* , "去年" */]
          },
          yAxis: {},
          series: [{
            name: '元',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: res.data
          }]
        });
      })
    },
  }
}

</script>

<style lang="scss" scoped>
.infobox {
  width: 800px;
  margin-top: 20px;
  margin-right: 20px;
}

.rankbox {
  width: 500px;
  margin-top: 20px;

  .tits {
    font-size: 18px;
    font-weight: bold;
    color: rgb(6, 81, 179);
    display: flex;

    .el-button {
      padding: 0;
    }
  }

  .rankul {
    padding: 0;
    margin-left: 0;
    list-style: none;
    height: 205px;
    overflow-y: scroll;

    li {
      display: flex;
      line-height: 30px;

      .lefts {
        flex: 1;
      }

      .rights {
        width: 100px;
      }
    }

    .name {
      // color: rgb(6, 81, 179);
      font-weight: bold;
    }

    .amountxs {
      margin-left: 10px
    }
  }
}

.infoItem {
  margin-bottom: 25px;
}

.chartsbox {
  flex: 1;
  /* width: 800px; */
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// Main.vue?f394dc6e